if (!customElements.get('terms-policies-modal')) {
  customElements.define(
    'terms-policies-modal',
    class TermsPoliciesModal extends ModalDialog {
      constructor() {
        super();
        this.storageKey = this.dataset.storageKey || 'termsPoliciesAgreed';
        this.agreeButton = this.querySelector('[data-terms-agree]');
        if (this.agreeButton) {
          this.agreeButton.addEventListener('click', this.onAgree.bind(this));
        }
      }

      static hasAgreed(storageKey = 'termsPoliciesAgreed') {
        try {
          return window.localStorage.getItem(storageKey) === 'true';
        } catch (e) {
          return false;
        }
      }

      isAccepted() {
        return TermsPoliciesModal.hasAgreed(this.storageKey);
      }

      show(productForm) {
        this.pendingProductForm = productForm || null;
        super.show(productForm?.submitButton || document.activeElement);
      }

      onAgree() {
        try {
          window.localStorage.setItem(this.storageKey, 'true');
        } catch (e) {
          // Ignore storage errors and still allow add to cart for this session
        }

        const productForm = this.pendingProductForm;
        this.pendingProductForm = null;
        this.hide();

        if (productForm && typeof productForm.addToCart === 'function') {
          productForm.addToCart();
        }
      }

      hide() {
        this.pendingProductForm = null;
        super.hide();
      }
    }
  );
}
